//
// Copyright (c) 2011-2024 by Curalate, Inc
//

import React from 'react';
import styled from 'styled-components';

import {
  BodyText,
  LinkPrimaryText,
  SubtitleText,
} from '@components/atoms/text/Text';
import { Upload } from '@components/molecules/upload/Upload';
import { ContentDrawerTrackingIds } from '@content-drawer/contentDrawerConstants';
import { useUploader } from '@content-drawer/upload/useUploader';
import empty from '@images/content-library/cl_illy_empty.svg';

export const EmptyMediaPanel = () => {
  const { uploadFile } = useUploader();

  const onUploadFiles = async (files: FileList | null) => {
    if (files) {
      const list = Array.from(files);
      list.forEach((file) => uploadFile(file));
    }
  };

  return (
    <Wrapper>
      <Image src={empty} alt='Empty list of the media items' />
      <SubtitleText>Add Media to Your Library</SubtitleText>
      <BodyText>
        Drop photos or videos onto any page to upload them to your Library You
        can also click the "Upload" button to browse files on your computer or
        click "Add to Library" on any media you find in Bazaarvoice Vibe.
      </BodyText>
      <BodyText>
        Media that you upload will be available here so that you can find and
        use it later.
        <LinkPrimaryText>
          <a
            href='https://support.bazaarvoice.com/s/article/Adding-Items-to-Media-Library?language=en_US'
            target='_blank'
            rel='noreferrer'
          >
            Learn more
          </a>
        </LinkPrimaryText>
      </BodyText>
      <Upload
        isDisabled={false}
        shouldAcceptMultipleFiles={true}
        handleChange={onUploadFiles}
        trackingId={ContentDrawerTrackingIds.UPLOAD_MEDIA}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacings[2]};
    margin: ${theme.spacings[5]};
    padding: ${theme.spacings[5]};
    border: ${theme.borderWidths[1]} solid ${theme.colors.gray1};
    border-radius: ${theme.borderRadii[2]};
    background: ${theme.colors.gray0};
  `,
);

const Image = styled.img(
  ({ theme }) => `
    margin: ${theme.spacings[5]};
  `,
);
